import { useTranslation } from 'react-i18next';

export function TeamSection() {
  const { t } = useTranslation();
  
  const team = [
    {
      name: t('team_ceo_name'),
      position: t('team_ceo_position'),
      description: t('team_ceo_desc'),
      image: 'https://static.readdy.ai/image/efe453aa8b08959c7487fe5d411998a7/0a3069cea53dea4aefd5083e1d00c4c9.png',
      icon: 'ri-user-star-line'
    },
    {
      name: t('team_sales_name'),
      position: t('team_sales_position'),
      description: t('team_sales_desc'),
      image: 'https://static.readdy.ai/image/efe453aa8b08959c7487fe5d411998a7/8b7d98d5c2a17b2d871d1247454e6fd1.jpeg',
      icon: 'ri-line-chart-line'
    }
  ];

  return (
    <section id="team" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {t('team_title')}<span className="text-blue-600">{t('team_title_highlight')}</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('team_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {team.map((member, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
            >
              <div className="aspect-[4/5] overflow-hidden bg-gray-100">
                <img 
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 text-blue-600 rounded-lg mb-4">
                  <i className={`${member.icon} text-2xl`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{member.name}</h3>
                <p className="text-blue-600 font-medium mb-4">{member.position}</p>
                <p className="text-gray-600 leading-relaxed text-sm">{member.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
